import { ApiError } from '~/components/Providers/APIClient';

function ApiErrorComponent(apiError: ApiError) {
    return (
        <div className="flex w-full self-center items-center justify-center m-auto flex-row">
            <h1 className="text-5xl w-fit p-2 text-primary">
                {apiError.status ?? '500'}
            </h1>
            <p className="text-xl border-l-2 border-secondary-light p-2 text-secondary-foreground">
                {apiError.message}
            </p>
        </div>
    );
}

export default ApiErrorComponent;
